import Pattern from '../ASSETS/RokuEnPattern.png';

export const NoGradientBackground = `url(${Pattern})`;
export const GradientBackground = `radial-gradient(transparent, black 100%), url(${Pattern})`;
